import React, { Component } from 'react'
// import {connect} from 'react-redux'
import { Box } from 'reactjs-admin-lte'
import { Button, ButtonToolbar, FormGroup, Row, Col, FormControl, ControlLabel, DropdownButton, MenuItem, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import TyreStore from 'stores/TyreStore'
import StockStore from 'stores/StockStore'
import WorkdocStore from 'stores/WorkdocStore'
import CKAutocomplete from 'component/element/CKAutocomplete'
// import InputNumber from 'rc-input-number'
import RemarkRecordModal from 'component/element/RemarkRecordModal'
import IframeModal from 'component/element/IframeModal'
import ConfirmPopup from 'component/element/ConfirmPopup'
import Select from 'react-select'
import ReportAssetVehiclePage from './report-asset-vehicle-page/ReportAssetVehiclePage'
import _ from 'lodash'
import DNDRowItem from '../ssp/RowItem'
const NotificationSystem = require('react-notification-system')
const DEFAULT_ROW = 10
class TyreRepairInsideDoc extends Component {
    constructor(props) {
       super(props)
      
       this.state = {
            loading:false,
            trNo:undefined,
            customerList:[],
            stockApproverList:[],
            car_registration_no_list:[],
            doc:{response_by:'',request_by:'',tyre_repair_no:'',seq_no:'',added_date:'',vehicle_id:'',amount:'',trash_flag:'',added_by:'',description:'',type_repair_no:'',vehicle_registration_no:'',tyre_repair_type:''},
            itemlist:[],
            showRemark:false,
            showConfirm:false,
            msgConfirm:'',
            showAssetVehicle:false,
            rowSelect:null,
			can_drag:false,
			darg_id:null
        }
    }
  
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
    }

    componentWillReceiveProps(newProps) {
        if (newProps.onShow&&this.props.onShow!==newProps.onShow){
            this.loadWorkdocAutocompleteOfficer()
            this.loadWorkdocAutocompleteStockApprover()
            this.loadCarRegistrationNo()
        }    
    }  

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    setDocAmount() {
        let {itemlist} = this.state
        let _amount = 0
        itemlist.forEach((item,index)=>{
            let amount = (item.amount===''||item.amount===null||item.amount===undefined||isNaN(item.amount)?0:item.amount)
            _amount += amount*1
        })
        return _amount
    }

    sortRowIndex(itemlist) {
        itemlist = itemlist.map((item,index)=>{
            item.seq = (index+1).toString()
            return item
        })
        return itemlist
    }

    newEmptyRow(number) {
        let {itemlist} = this.state
		let NUMBER = itemlist.length===0?'1':(itemlist.length+1).toString()
        return new Array(number).fill(null).map((item,index) => {
            return {
                amount:'',
                brand:'',
                detail:'',
                invoice_date:'',
                mileage:'',
                model:'',
                seq:NUMBER,
                serial_no:'',
                tyre_repair_item_id:0,
                tyre_repair_no:'',
                tyrecode:'',
                vehicle_id:'',
                vehicle_registration_no:'',
                wheel_at:''
            }
        })
    }
    
    loadNewDoc() {
        let {itemlist,doc,trNo} = this.state
        this.setState({loading:true})
        TyreStore.loadNewReportRepairInsideDoc((result)=>{
            doc = Object.assign(doc,result.data.doc)
            trNo = doc.tyre_repair_no
            itemlist = result.data.itemlist
            itemlist = this.newEmptyRow(DEFAULT_ROW) 
            itemlist = this.sortRowIndex(itemlist)
            this.setState({loading:false,doc:doc,itemlist:itemlist,trNo:trNo})
        })
    }

    loadData(trNo) {
        let {itemlist,doc} = this.state
        this.setState({loading:true,trNo:trNo})
        TyreStore.loadReportRepairInsideDoc(trNo,(result)=>{
            doc = Object.assign(doc,result.data.doc)
            doc.amount = this.setDocAmount()
            itemlist = result.data.itemlist
            if (itemlist.length===0) {
                itemlist = this.newEmptyRow(DEFAULT_ROW)
            } else {
                if (itemlist.length<DEFAULT_ROW) {
                    itemlist = itemlist.concat(this.newEmptyRow(DEFAULT_ROW-itemlist.length))
                }
            }    
            itemlist = this.sortRowIndex(itemlist)
            this.setState({loading:false,doc:doc,itemlist:itemlist})
        })
    }
    
    loadWorkdocAutocompleteOfficer() {
        let officer = []
        WorkdocStore.loadWorkdocAutocompleteOfficer((result)=>{
            result.data.forEach(element => {
                officer.push({
                    id: element.Value,
                    label: element.Name,
                    emp_id: element.employee_id
                })
            })
          this.setState({customerList:officer})
        })  
    }  
    
    loadWorkdocAutocompleteStockApprover() {
        let approver = []
        WorkdocStore.loadWorkdocAutocompleteStockApprover((result)=>{
            result.data.forEach(element => {
                approver.push({
                    id: element.Value,
                    label: element.Name,
                    emp_id: element.employee_id
                })
            })
          this.setState({stockApproverList:approver})
        })  
    }
    
    loadCarRegistrationNo() {
        let {doc} = this.state
        let car = []
        StockStore.loadCarRegistrationNo(doc.vehicle_registration_no,(result)=>{
            result.data.forEach(element => {
                car.push({
                    id: element.Value,
                    label: element.Name,
                    car_info: element.car_info,
                    work_no :element.work_no
                })
            })
            this.setState({car_registration_no_list:car})
        })
    }

    onRowAdd(number) {
        let {itemlist} = this.state
        itemlist = itemlist.concat(this.newEmptyRow(number))
        this.setState({itemlist:itemlist})
    }

    onSaveClick() {
        this.saveTRDoc()
    }

    saveTRDoc() {
        let {doc,itemlist} = this.state
        let postData = {doc:doc,itemlist:itemlist}
        this.setState({loading:true})
        TyreStore.saveTyreRepairInsideDoc(this.state.trNo,postData,(result)=>{
            if (result.status==='OK') {
                doc.seq_no = result.seq_no
                this.setState({loading:false,doc:doc})
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการบันทึกรายการใบงานบันทึกผู้ถือครองเรียบร้อย',
                    level:'info',
                    position:'tc'
                })
            }
        },()=>{
            this.setState({loading:false})
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำการบันทึกรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
        })
    }

    onCloseClick() {
        if (this.props.onCloseClick!==undefined)
            this.props.onCloseClick()
    }

    onTextChange(field,e) {
        let {doc} = this.state
        doc[field] = e.target.value
        this.setState({doc:doc})
        if (field==='vehicle_registration_no')
            this.loadCarRegistrationNo()
    }

    onTextSelect(field,e) {
        let {doc} = this.state
        doc[field] = e
        this.setState({doc:doc})
    }

    onRowTextChange(index,field,e) {
        let {itemlist,doc} = this.state
        itemlist[index][field] = (field==='mileage'||field==='amount'?e:e.target.value)
        doc.amount = this.setDocAmount()
        this.setState({itemlist:itemlist,doc:doc})
    }

    onDeleteRowClick(index) {
        let {itemlist,doc} = this.state
        itemlist.splice(index,1) 
        this.setState({itemlist:itemlist,doc:doc})
        this.saveTRDoc()
    }

    onDropdownSelect(e) {
        if (e==='2') {
            this.setState({showConfirm:true,msgConfirm:'ยืนยันการทำรายการเปลี่ยนสถานะเป็นจ่ายเงินแล้วหรือไม่ ?'})
        } else if (e==='3') {
            this.setState({showConfirm:true,msgConfirm:'ยืนยันการทำรายการยกเลิกใบงานบันทึกผู้ถือครองหรือไม่ ?'})
        } else if (e==='4') {
            this.setState({showRemark:true})
        }
    }

    onConfirmClick() {
        let status = ''
        if (this.state.msgConfirm==='ยืนยันการทำรายการเปลี่ยนสถานะเป็นจ่ายเงินแล้วหรือไม่ ?') {
            status = '1'
        } else if (this.state.msgConfirm==='ยืนยันการทำรายการยกเลิกใบงานบันทึกผู้ถือครองหรือไม่ ?') {
            status = '0'
        }
        let postData = {tyre_repair_no:this.state.trNo,status:status}
        TyreStore.updateTyreRepairInsideDoc(status,postData,(result)=>{
            if (result.status==='OK') {
                let _msg = ''
                if (status==='1')
                    _msg = 'เปลี่ยนสถานะเป็นจ่ายเงินแล้ว '
                else
                    _msg = 'ยกเลิก'
                
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการ'+_msg+'ใบงานบันทึกผู้ถือครองเลขที่ '+this.state.trNo+' เรียบร้อย',
                    level:'info',
                    position:'tc'
                })
                this.setState({showConfirm:false,msgConfirm:''})
            }
        },()=>{
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
            this.setState({showConfirm:false,msgConfirm:''})
        })
    }

    onPrintClick(){
        let {trNo} = this.state
        let url = './pdf/v2?startPage=PrintTyreRepairDoc&trNo='+trNo
        if (process.env.NODE_ENV === "development") {
            url = '?startPage=PrintTyreRepairDoc&trNo='+trNo
        }
        this.refs.iframe.loadUrl(url)
    }

    onRemarkDeleteRecordClick() {
        this.setState({loading:true})
        TyreStore.delTyreRepairInsideDoc(this.state.trNo,(result)=>{
            if (result.status==='OK') {
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการลบรายการใบงานบันทึกผู้ถือครองเลขที่ '+this.state.trNo+' เรียบร้อย',
                    level:'info',
                    position:'tc'
                })
                this.setState({loading:false,showRemark:false})
                this.onCloseClick()
            }
        },()=>{
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำการลบรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
            this.setState({loading:false,showRemark:false})
        })
    }

    onTyreRepairTypeChange(e) {
        let {doc} = this.state
        if (e===null) {
            doc.tyre_repair_type = ''
        } else {
            doc.tyre_repair_type = e.value
        }
        this.setState({doc:doc})
    }

    onSerialNoKeyPress(item,index) {
        let {itemlist} = this.state
        TyreStore.loadSearchTyreSerial(item.serial_no,(result)=>{
            if (result.data.length>0) {
                let checkDup = itemlist.findIndex(x=>x.serial_no===result.data[0].serial_no&&x.tyre_repair_item_id===result.data[0].itemnum)
                if (checkDup===-1) {
                    itemlist[index].amount = result.data[0].price_per_unit*result.data[0].quantity
                    itemlist[index].brand = result.data[0].tyre_brand
                    itemlist[index].detail = result.data[0].description
                    itemlist[index].invoice_date = ''
                    itemlist[index].mileage = result.data[0].tyre_mileage
                    itemlist[index].model = result.data[0].tyre_model
                    itemlist[index].seq = ''
                    itemlist[index].serial_no = result.data[0].serial_no
                    itemlist[index].tyre_repair_item_id = result.data[0].itemnum
                    itemlist[index].tyre_repair_no = ''
                    itemlist[index].tyrecode = ''
                    itemlist[index].vehicle_id = ''
                    itemlist[index].vehicle_registration_no = ''
                    itemlist[index].wheel_at = ''
                } else {
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message:'ไม่สามารถเพิ่มรายการได้ เนื่องจากมียางหมายเลข "'+result.data[0].serial_no+'" นี้อยู่แล้ว',
                        level:'error',
                        position:'tc'
                    })
                }    
            }    
            this.setState({itemlist:itemlist})
        })
    }

    onRegistrationSearchClick(index) {
        this.setState({showAssetVehicle:true,rowSelect:index})
    }

    onAssetVehicleSelect(item) {
        let {rowSelect,itemlist} = this.state
        let index = rowSelect
        itemlist[index].vehicle_id = item.vehicle_id
        itemlist[index].vehicle_registration_no = item.vehicle_registration_no
        this.setState({showAssetVehicle:false,rowSelect:null})
    }

    renderHeaderRow() {
        return (
            <div>           
                <Row>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel>เลขที่ใบสั่งซื้อ</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <FormControl type="text" placeholder="<เลขที่ถูกสร้างอัตโนมัติ>" className="input-dark" />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel>วันที่</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <FormControl type="text" placeholder="" className="input-dark" value={this.state.doc.added_date} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <ControlLabel>รหัสรถ</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <FormControl value='' onChange={()=>{}} />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            
                        </FormGroup>
                    </Col>
                </Row>    
            </div>
        )          
    }

    renderColDetail(index,item) {
        let {can_drag,darg_id} = this.state
        let uniq = item.seq
        let hover = (
            <OverlayTrigger
                key={'right'}
                placement={'right'}
                overlay={
                    <Tooltip id={'tooltip-right'}>
                        Hold & darg to sort the Items
                    </Tooltip>
                }
                >
                <div className='wrap-tool'>
                    <div className='card-tool'><FontAwesome name='bars' /></div>
                </div>
            </OverlayTrigger>
        )
        return([
            <td 
                key={0} 
                className='text-center'
                style={{verticalAlign:'middle',width:'50px',minWidth:'50px'}}
                onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}} 
                onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}}
            >
                {can_drag&&darg_id===uniq?hover:index+1}
            </td>,
            <td key={1} className='text-center'>
                <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'serial_no')} value={item.serial_no} onKeyPress={this.onSerialNoKeyPress.bind(this,item,index)} />
            </td>,
            <td key={2} className='text-center'>
                <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'brand')} value={item.brand} />
            </td>,
            <td key={3} className='text-center'>
                <CKAutocomplete
                    top={'-34px'}
                    items={[
                        {label:'09.00-20',id:'09.00-20'},
                        {label:'10.00-20',id:'10.00-20'},
                        {label:'11.00-20',id:'11.00-20'},
                        {label:'10R22.5',id:'10R22.5'},
                        {label:'11R22.5',id:'11R22.5'},
                        {label:'295R22.5',id:'295R22.5'},
                        {label:'18.4-24',id:'18.4-24'},
                        {label:'17.5-24',id:'17.5-24'},
                        {label:'20.5-25',id:'20.5-25'}
                    ]}
                    value={''}
                    onChange={()=>{}}
                    onSelect={()=>{}}
                    shouldItemRender={null}
                />
            </td>,
            <td key={4} className='text-left'>
                <Select
                    onChange={()=>{}}
                    options={[{label:'ยางใหม่',value:'ยางใหม่'},{label:'ยาง %',value:'ยาง %'},{label:'ยางหล่อดอก',value:'ยางหล่อดอก'},{label:'ปลด / เลิกใช้',value:'ปลด / เลิกใช้'}]}
                    value=''
                    placeholder='เลือก'
                />
            </td>
        ])
    }
    
    renderRowData() {
        let {itemlist,can_drag} = this.state
        if (itemlist.length===0) {
            return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
        } else {
            return itemlist.map((item,index)=> {
				return <DNDRowItem 
					key={index} 
					id={item.seq}
					item={item}
					can_drag={can_drag}
					moveRow={this.onMoveRow.bind(this)}
					renderColDetail={this.renderColDetail.bind(this,index)}
				/>
			})
        }
    }

    onMoveRow(id,afterId) {
        let {itemlist} = this.state
        var rows = _.clone(itemlist);
        var currentRow = _.filter(rows, function (r) { return r.seq === id; })[0];
        var afterRow = _.filter(rows, function (r) { return r.seq === afterId; })[0];
    
        var currentRowIndex = rows.indexOf(currentRow);
        var afterRowIndex = rows.indexOf(afterRow);
    
        // remove the current row
        rows.splice(currentRowIndex, 1);
        // put it after
        rows.splice(afterRowIndex, 0, currentRow);
    
        itemlist = rows
        this.setState({itemlist: itemlist});
    }

    renderTable() {
        return(
            <div className='table-responsive'>
                <table className="table table-hover table-bordered-solid" style={{minWidth:'1280px',marginBottom:'0'}}>
                    <thead>
                        <tr>
                            <th style={{width:'50px'}} className='text-center'>ลำดับ</th>
                            <th style={{width:'120px'}} className='text-center'>Serial ยางรถ</th>
                            <th style={{width:'120px'}} className='text-center'>ยี่ห้อยาง</th>
                            <th style={{width:'100px'}} className='text-center'>ขนาดยาง</th>
                            <th style={{width:'100px'}} className='text-center'>สถานะยาง</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRowData()}
                    </tbody>  
                </table>
            </div>
        )    
    }

    renderNewItemButton() {
        return(
            <Row style={{marginTop:'10px'}}>
                <Col md={12}>
                    <ButtonToolbar>
                        <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
                        <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;เพิ่ม 10 รายการ</Button>
                    </ButtonToolbar>        
                </Col>
            </Row>
        )
    }

    renderRemark() {
        return (
            <Row style={{marginTop:'10px'}}>
                <Col lg={3} md={3} sm={6}>
                    <FormGroup
                        controlId={null}
                        validationState={null}
                    >
                        <ControlLabel>หมายเหตุ</ControlLabel>
                        <FormControl value={this.state.doc.remark===null?'':this.state.doc.remark} componentClass="textarea" style={{height:'150px'}} onChange={this.onTextChange.bind(this,'remark')} />            
                    </FormGroup>
                </Col>  
            </Row>
        )
    }

    renderAssetVehicleModal() {
        return(
            <Modal
                show={this.state.showAssetVehicle}
                onHide={()=>{this.setState({showAssetVehicle:false,rowSelect:null})}}
                dialogClassName="midwidth-dialog"
            >
                <Modal.Header closeButton>
                    <Modal.Title>เลือกรายการยานพาหนะ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ReportAssetVehiclePage
                        mode='tyre-repair-inside-doc'
                        onRowSelect={this.onAssetVehicleSelect.bind(this)}
                    />
                </Modal.Body>
            </Modal>        
        )
    }

    render() {
        let {loading,trNo,doc} = this.state
        return(
            <div>
                <Box loading={loading}>
                    <Box.Header className='text-center'>
                        <Box.Title>
                            {'ใบงานบันทึกผู้ถือครองเลขที่ '+trNo}
                        </Box.Title>
                        <Box.Tools className='pull-right'>
                            <Button bsClass='bg-maroon btn' onClick={this.onPrintClick.bind(this)}><FontAwesome name='print' />&nbsp;พิมพ์เอกสาร</Button>&nbsp;
                            {doc.seq_no!==''?
                            <DropdownButton
                                bsStyle={'primary'}
                                title={'เปลี่ยนสถานะ'}
                                key={0}
                                id={'dropdown-invoice-status-menu-button'}
                                onSelect={this.onDropdownSelect.bind(this)}
                            >	      
                                <MenuItem eventKey="2"><FontAwesome name='money'/> จ่ายเงินแล้ว</MenuItem>
                                <MenuItem eventKey="3"><FontAwesome name='ban'/> ยกเลิก</MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="4"><FontAwesome name='trash'/> ลบเอกสาร</MenuItem>
                            </DropdownButton> 
                            :''}
                        </Box.Tools>
                    </Box.Header>
                    <Box.Body>
                        {this.renderHeaderRow()}
                        {this.renderTable()}
                        {this.renderNewItemButton()}
                        {this.renderRemark()}
                    </Box.Body>
                    <Box.Footer>
                        <ButtonToolbar className='pull-right'>
                            <Button bsStyle='primary' onClick={()=>{}}><FontAwesome name='save' />&nbsp;บันทึก</Button>
                            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;ปิดเอกสาร</Button>
                        </ButtonToolbar>
                    </Box.Footer>
                </Box>
                <NotificationSystem ref="notificationSystem" />
                <IframeModal ref='iframe'  title={'พิมพ์เอกสาร'} />
                <RemarkRecordModal
                    show={this.state.showRemark}
                    docTitle='ลบใบงานบันทึกผู้ถือครอง'
                    docName='tyrerepair'
                    docNo={trNo}
                    docTag=''
                    onModalClose={()=>{this.setState({showRemark:false})}}
                    onSuccess={this.onRemarkDeleteRecordClick.bind(this)}
                />
                <ConfirmPopup
                    show={this.state.showConfirm}
                    message={this.state.msgConfirm}
                    onConfirm={this.onConfirmClick.bind(this)}
                    onHide={()=>{this.setState({showConfirm:false,msgConfirm:''})}}
                />
                {this.renderAssetVehicleModal()}
            </div>
        )
    }
}

TyreRepairInsideDoc.defaultProps = {
        
}
      
export default TyreRepairInsideDoc;


// WEBPACK FOOTER //
// ./src/view/tyre/TyreVehicleRegistrationDoc.js